import axios from "axios"
import store from "../store"
import i18n from "@/lang/lang"

axios.defaults.timeout = process.env.VUE_APP_API_TIMEOUT
axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL

//Http Request
axios.interceptors.request.use(
  config => {
    var token = localStorage.getItem("token")
    if (token) {
      config.headers.Authorization = "Access " + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//Http Response
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.data.error.code) {
      error.response.data.error.message = i18n.t("APIErrors.__" + error.response.data.error.code)
    }
    switch (error.response.status) {
      case 403:
        store.dispatch("account/updateUsedBiz", null)
        store.dispatch("bizes/updateBizInfo", null)
        break
      case 404:
        // store.dispatch(
        //     "global/showAlertError",
        //     error.response.data.error.message
        // )
        // if (error.response.data.error.code == "NOT_FOUND_ERROR") {
        //     store.dispatch("account/updateUsedBiz", null)
        //     store.dispatch("bizes/updateBizInfo", null)
        // } else {
        //     store.dispatch(
        //         "global/showAlertError",
        //         error.response.data.error.message
        //     )
        // }
        break

      default:
        store.dispatch("global/showAlertError", error.response.data.error.message)
    }

    // error.response.data.text = error.response.data.errorCode? errorHandler[error.response.data.errorCode] : error.response.data.message
    return Promise.reject(error)
  }
)

export default axios
